import { ReactNode } from 'react';
import styles from './Modal.module.css';

export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: ReactNode;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    headerActions?: ReactNode; // Botones adicionales en el header
    closeOnOverlayClick?: boolean; // Si se cierra al hacer clic fuera (default: true)
}

export const Modal = ({ isOpen, onClose, title, children, size = 'md', headerActions, closeOnOverlayClick = true }: ModalProps) => {
    if (!isOpen) return null;

    const handleOverlayClick = () => {
        if (closeOnOverlayClick) {
            onClose();
        }
    };

    return (
        <div className={styles['modal-overlay']} onClick={handleOverlayClick}>
            <div className={`${styles.modal} ${styles[`modal-${size}`]}`} onClick={(e) => e.stopPropagation()}>
                {title && (
                    <div className={styles['modal-header']}>
                        <h3>{title}</h3>
                        {headerActions && (
                            <div className={styles['modal-header-actions']}>
                                {headerActions}
                            </div>
                        )}
                    </div>
                )}
                <div className={styles['modal-body']}>{children}</div>
            </div>
        </div>
    );
};
